import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-store-01',
  standalone: true,
  templateUrl: '../../assets/store-01.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamStore01Icon {}
